import VirtualizedTable from "../../../Grids/VirtualizedTable";
import dayjs from "dayjs";
import APICom from "../../../../utils/helpers/APICom";
import PersistStorage from "../../../../utils/helpers/PersistStorage";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Icon } from '@iconify/react';
import phoneIcon from '@iconify-icons/mdi/phone';
import smsIcon from '@iconify-icons/mdi/email';
import checkIcon from '@iconify-icons/mdi/check-circle';
import sendIcon from '@iconify-icons/mdi/send-variant';
import closeIcon from '@iconify-icons/mdi/close-circle';
import callConfirmed from '@iconify-icons/mdi/phone-check';
import callCancel from '@iconify-icons/mdi/phone-cancel';
import phoneMissed from '@iconify-icons/mdi/phone-missed';
import Scheduled from '@iconify-icons/mdi/phone-schedule';
import refreshIcon from '@iconify-icons/mdi/refresh';

import NotScheduled from '@iconify-icons/mdi/cellphone-remove';
import SMSConfirmed from '@iconify-icons/mdi/tooltip-cellphone';
import SMSCancelled from '@iconify-icons/mdi/message-bulleted-off';
import SMSNoResponse from '@iconify-icons/mdi/message-alert';
import { toast } from 'react-toastify';
import {Modal, Button} from "react-bootstrap";
import RouteIcon from '@iconify-icons/mdi/directions-fork';

export default function RoboCallNotification() {


    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [modalClass, setModalClass] = useState("");
    const [modalHeaderText, setModalHeaderText] = useState("");
    const [modalBodyHTML, setModalBodyHTML] = useState(null);
    const [modalFooterHTML, setModalFooterHTML] = useState(
        <Button variant='dark' className="border-0" onClick={()=>setShowDynamicModal(false)}>
          OK
        </Button>
    );

    const [ShowGridLoader, setShowGridLoader] = useState(false);
    const tableRef = useRef(null);
    const [initialSelectedRows, setInitialSelectedRows] = useState([]);

    const handleSelectedRows = async () => {
        const selectedRows = tableRef.current?.getSelectedRows() ?? [];
        let selectedConfirmationNumbers = GetSelectedRowsConfirmationNo(selectedRows);
        if(selectedConfirmationNumbers){

            let countOfAlredySuccessDeliveryStatus = GetAlreadyDeliveredRows(selectedRows);
            if(countOfAlredySuccessDeliveryStatus > 0){
                let userValidation = false;
                userValidation = await showConfirmationModal("Some of the selected request(s) have already been processed. Do you still want to proceed with them?", "Warning");
                if(userValidation === false) 
                {
                
                }
                else if(userValidation === true){
                    setShowGridLoader(true);
                    await CallRoboCallService(selectedConfirmationNumbers);
                    setShowGridLoader(false);
                }
            }
            else{
              setShowGridLoader(true);
              await CallRoboCallService(selectedConfirmationNumbers);
              setShowGridLoader(false);
            }
        }
    };

    const RefreshData = async () => {
        try {
            setShowGridLoader(true);
            await fetchNotifications();
            setShowGridLoader(false);
        } catch (error) {
            
        }

    }
          
    function GetSelectedRowsConfirmationNo(selectedRows){
        let confirmationNumber = "";
        try {
            if(selectedRows){
                const confirmationNos =  selectedRows.map(row => row.TripNo);
                const confirmationNoList = confirmationNos.join(",");
                if(confirmationNoList != undefined){
                    confirmationNumber = confirmationNoList.toString();
                }
            }    
        } catch (error) {
            return "";
        }
        return confirmationNumber;
    }

    const [summaryData, setSummaryData] = useState(null);

    const [rowData, setRowData] = useState([]);
    const [columns, setColumns] = useState([]);

    const columnsToHide = ["AddedFromGrid", "RoboCallPerformed"];
    
    const { loginData } = useSelector((store) => store.login);
    const { AffiliateData } = useSelector((store) => store.combinedata);

    const loginUserAffiliateList = loginData.UserAffiliateList.includes(",")
    ? loginData.UserAffiliateList.split(",")
    : [loginData.UserAffiliateList];

    const passedAff = PersistStorage.retrieve("passedAff", true);
    const currentAffiliate =
      loginUserAffiliateList.find((item) => item === String(passedAff)) ?? "";

    const [selectedDate, setSelectedDate] = useState(dayjs().format("YYYY-MM-DD"));
    const tempAffiliate = AffiliateData.find(
        (item) => item.iOutTSPID.toString() === currentAffiliate.toString()
      );
      const isBroker = tempAffiliate && tempAffiliate.bBroker === 1;
      const finalAffiliate = isBroker ? tempAffiliate.iInTSPID : currentAffiliate;

    useEffect(() => {
        fetchNotifications();
    }, [selectedDate]);

    useEffect(() => {
        const fetchData = async () => {
          try {
            setShowGridLoader(true);
            await fetchNotifications();
          } finally {
            setShowGridLoader(false);
          }
        };
      
        fetchData();
      }, [selectedDate]);

    useEffect(() => {
        if (Array.isArray(rowData) && rowData.length > 0) {
          const preSelected = {};
          rowData.forEach((row) => {
            if (row.AddedFromGrid) {
              preSelected[row.TripNo.toString()] = true; // convert to string
            }
          });
          setInitialSelectedRows(preSelected);
        } else {
          setInitialSelectedRows({});
        }
    }, [rowData]);
    
    
    
    async function fetchNotifications() {
        try {
          const response = await APICom.fetchData(
            "GenericManifestDotNetCoreURL",
            `api/Notification/GetNotifications?iAffiliateId=${finalAffiliate}&date=${selectedDate}`,
            "get",
            { "Content-Type": "application/json" }
          );
    
          if (response && response.data) {
            const summary = response.data.summary;
            const data = response.data.data;
    
            setSummaryData(summary);
            setRowData(data);
    
            if (data.length > 0) {


            const cols = Object.keys(data[0]).map((key) => ({
                accessorKey: key,
                header: key.charAt(0).toUpperCase() + key.slice(1),
                enableColumnFilter: true,
                filterFn: "includesString",
            }));

            const customized = cols.map((col) => {
                if (col.accessorKey === "Sent_Time") return { ...col, size: 250 };
                if (col.accessorKey === "Customer_Name") return { ...col, size: 250 };
                if (col.accessorKey === "ResponseTimestamp") return { ...col, size: 250 };
                return col;
              });
              setColumns(customized);
            }
          }
        } catch (err) {
          console.error("Error fetching notifications:", err);
          setRowData([]);
          setColumns([]);
          setSummaryData(null);
        }
      }


      const CallRoboCallService = async (selectedRows) => {
        try {
            const payload = {
                refIds: selectedRows,
                affiliateID: finalAffiliate
            };
            const response = await APICom.fetchData(
                "GenericManifestDotNetCoreURL",
                "api/Notification/MarkRobocall",
                "post",
                { "Content-Type": "application/json" },
                payload
            );
            if (response && response.data) {
                console.log("API response:", response.data);
                if(response.data == "Mark robocall successfully."){
                    toast.success("Robocall: Requests marked successfully for the selected trip(s).", {
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true
                    });

                    
                }
                else{
                    toast.error("An Error occured while marking request(s) as RoboCall", {
                        autoClose: 6000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true
                    });
                }
                await fetchNotifications();
                setShowGridLoader(false);
            }
        } catch (error) {
            setShowGridLoader(true);
            toast.error("An Error occured while marking request(s) as RoboCall", {
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true
              });
              await fetchNotifications();
              setShowGridLoader(false);
        }
    }

    const getRowStyle = (row) => {
        
        const isEven = row.index % 2 === 0;
        switch (row.Call_Delivery_Status.toString().toLowerCase()) {
          case "success":
            return { backgroundColor: "#d4edda", borderBottom: "1px solid rgb(94 94 94)" };
          case "fail":
            return { backgroundColor: "#f8d7da", borderBottom: "1px solid rgb(94 94 94)" };
          case "failed":
            return { backgroundColor: "#f8d7da", borderBottom: "1px solid rgb(94 94 94)" }
          case "busy":
            return { backgroundColor: "#fff3cd", borderBottom: "1px solid rgb(94 94 94)" };
          default:
            return { borderBottom: "1px solid rgb(94 94 94)"};
            return {};
        }
    };

    function GetAlreadyDeliveredRows(selectedRows) {
        try {
          if (!Array.isArray(selectedRows)) return 0;
      
          const successCount = selectedRows.filter(
            (row) => String(row.Call_Delivery_Status).toLowerCase() === "success"
          ).length;
      
          return successCount;
        } catch (error) {
          console.error("Error checking success rows:", error);
          return 0;
        }
    }

    const showConfirmationModal = (errorMsg, headerText = "Warning", yesButtonDark = true) => {
        return new Promise((resolve) => {
          const footerHandler = (
              <>
                <Button variant={yesButtonDark == true ? 'dark' : 'secondary'} className="border-0" onClick={() => {
                  setShowDynamicModal(false);
                  resolve(true);
                }}>
                  Yes
                </Button>
                <Button variant={yesButtonDark == true ? 'secondary' : 'dark'} className="border-0" onClick={() => {
                  setShowDynamicModal(false);
                  resolve(false);
                }}>
                  No
                </Button>
              </>
          );
      
          setModalHeaderText(headerText);
          setModalBodyHTML(errorMsg);
          setModalFooterHTML(footerHandler);
          setModalClass("");
          setShowDynamicModal(true);
        });
    };

    return (

        <>
        {showDynamicModal ? 
        <Modal centered className={modalClass} backdrop="static" keyboard={true} onKeyDown={(e)=>{
            if(e.key === "Enter")
            {
              e.preventDefault();
            }
          }} 
           show={showDynamicModal} animation={true}>
            <Modal.Header className='text-white user-select-none p-0 py-1 px-2 callAgent-modal-header' closeButton>
                <Modal.Title style={{fontSize:"20px"}}>{modalHeaderText}</Modal.Title>
            </Modal.Header>
            <Modal.Body className='fw-normal user-select-none'>{modalBodyHTML}</Modal.Body>
            {modalFooterHTML === ""? "":
              <Modal.Footer className='p-0 px-2 py-1'>
                {modalFooterHTML}
              </Modal.Footer>
            }
        </Modal>
      : ""}

        <div style={{ padding: "10px", paddingTop: "0px" }}>
            {ShowGridLoader ? <div className="loader"></div> : ""}
        <div style={{display: "inline-flex", alignItems: "center", gap: "10px", justifyContent: "center", width: "100%", marginTop: "2px", marginBottom: "2px", border: "1px solid #d3d3d3",borderRadius: "10px"}}>
        <div>
            <label style={{fontWeight: "bold"}}>Selected Date</label>
                <input
                    type="date"
                    id="dateFilter"
                    className="form-control"
                    style={{ maxWidth: "200px" }}
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                />
            </div>
            <div
                style={{
                    flexWrap: "wrap",
                    display: "inline-flex",
                    gap: "15px"
                }}
                >
                  <div>
                    <div style={{background:"#dbdbdb", textAlign: "center", paddingRight: "5px", paddingLeft: "5px", fontSize: "14px"}}>
                              <label>Total Calls/SMS</label>
                          </div>
                       <div
                       style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        border: "1px solid #ddd",
                        background: "white",
                        width: "auto",
                        paddingTop: "1px",
                        paddingBottom: "0px", 
                        justifyContent: "center"
                        }}
                       >
                        
                          <div style={{ fontSize: "12px", color: "black", display: "inline-flex", justifyContent: "center", alignItems: "center", fontWeight: "500"}}>
                          
                              <div style={{ fontSize: "20px", marginRight: "8px", color: "#555", display: "inline-flex" }}>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Total Calls"
                                >
                                  <Icon icon={phoneIcon} width="20" height="20" style={{color: "darkgreen"}} />
                                  <label>{summaryData?.["TotalCalls"]?.body ?? summaryData?.["TotalCalls"] ?? 0}</label>
                                </div>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Total SMS"
                                >
                                  <Icon icon={smsIcon} width="20" height="20" style={{color: "darkslateblue"}} />
                                  <label>{summaryData?.["TotalSMS"]?.body ?? summaryData?.["TotalSMS"] ?? 0}</label>
                                  </div>
                              </div>
                          </div>
                        </div>

                  </div>
                  <div>
                           <div style={{background:"#dbdbdb", textAlign: "center", paddingRight: "5px", paddingLeft: "5px", fontSize: "14px"}}>
                              <label>Call Success/Busy</label>
                          </div>
                       <div
                       style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        border: "1px solid #ddd",
                        background: "rgb(239 239 239)",
                        width: "auto",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        justifyContent: "center"
                        }}
                       >
                          <div style={{ fontSize: "12px", color: "black", display: "inline-flex", justifyContent: "center", alignItems: "center", fontWeight: "500"}}>
                              <div style={{ fontSize: "20px", marginRight: "8px", color: "#555", display: "inline-flex" }}>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Call Success"
                                >
                                  <Icon icon={checkIcon} width="20" height="20" style={{color: "forestgreen"}} />
                                  <label>{summaryData?.["Total_CallSuccess"]?.body ?? summaryData?.["Total_CallSuccess"] ?? 0}</label>
                                </div>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center", 
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Call Busy"
                                >
                                  <Icon icon={closeIcon} width="20" height="20" style={{color: "darkred"}} />
                                  <label>{summaryData?.["Total_CallBusy"]?.body ?? summaryData?.["Total_CallBusy"] ?? 0}</label>
                                  </div>
                              </div>
                          </div>
                        </div>
                  </div>
                  <div>
                           <div style={{background:"#dbdbdb", textAlign: "center", paddingRight: "10px", paddingLeft: "10px", fontSize: "14px"}}>
                              <label>Sch. Confirmed By Calls/SMS</label>
                          </div>
                       <div
                       style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        border: "1px solid #ddd",
                        background: "white",
                        width: "auto",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        justifyContent: "center"
                        }}
                       
                       >
                          <div style={{ fontSize: "12px", color: "black", display: "inline-flex", justifyContent: "center", alignItems: "center", fontWeight: "500"}}>
                              <div style={{ fontSize: "20px", marginRight: "8px", color: "#555", display: "inline-flex" }}>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Sch. Confirmed By Call"
                                >
                                  <Icon icon={callConfirmed} width="20" height="20" style={{color: "forestgreen"}} />
                                  <label>{summaryData?.["Total_Call_Confirmed"]?.body ?? summaryData?.["Total_Call_Confirmed"] ?? 0}</label>
                                </div>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center", 
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Sch. Confirmed By SMS"
                                >
                                  <Icon icon={SMSConfirmed} width="20" height="20" style={{color: "darkslateblue"}} />
                                  <label>{summaryData?.["Total_Sms_Confirmed"]?.body ?? summaryData?.["Total_Sms_Confirmed"] ?? 0}</label>
                                  </div>
                              </div>
                          </div>
                        </div>
                  </div>
                  <div >

                        <div style={{background:"#dbdbdb", textAlign: "center", paddingRight: "10px", paddingLeft: "10px", fontSize: "14px"}}>
                              <label>Req. Cancelled Calls/SMS</label>
                        </div>

                       <div
                       
                       style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        border: "1px solid #ddd",
                        background: "rgb(239 239 239)",
                        width: "auto",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        justifyContent: "center"
                        }}
                       >
                          <div style={{ fontSize: "12px", color: "black", display: "inline-flex", justifyContent: "center", alignItems: "center", fontWeight: "500"}}>
                              <div style={{ fontSize: "20px", marginRight: "8px", color: "#555", display: "inline-flex" }}>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Req. Cancelled By Call"
                                >
                                  <Icon icon={callCancel} width="20" height="20" style={{color: "red"}} />
                                  <label>{summaryData?.["Total_Call_Cancelled"]?.body ?? summaryData?.["Total_Call_Cancelled"] ?? 0}</label>
                                </div>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center", 
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Req. Cancelled By SMS"
                                >
                                  <Icon icon={SMSCancelled} width="20" height="20" style={{color: "darkslateblue"}} />
                                  <label>{summaryData?.["Total_Sms_Cancelled"]?.body ?? summaryData?.["Total_Sms_Cancelled"] ?? 0}</label>
                                  </div>
                              </div>
                          </div>
                        </div>
                  </div>
                  <div>
                        <div style={{background:"#dbdbdb", textAlign: "center", paddingRight: "10px", paddingLeft: "10px", fontSize: "14px"}}>
                              <label>Not Confirmed Calls/SMS</label>
                        </div>


                       <div
                       style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        border: "1px solid #ddd",
                        background: "white",
                        width: "auto",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        justifyContent: "center"
                        }}
                       >
                          <div style={{ fontSize: "12px", color: "black", display: "inline-flex", justifyContent: "center", alignItems: "center", fontWeight: "500"}}>
                              <div style={{ fontSize: "20px", marginRight: "8px", color: "#555", display: "inline-flex" }}>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Not Confirmed By Call"
                                >
                                  <Icon icon={phoneMissed} width="20" height="20" style={{color: "orange"}} />
                                  <label>{summaryData?.["Total_Call_NoResponse"]?.body ?? summaryData?.["Total_Call_NoResponse"] ?? 0}</label>
                                </div>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center", 
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Not Confirmed By SMS"
                                >
                                  <Icon icon={SMSNoResponse} width="20" height="20" style={{color: "darkslateblue"}} />
                                  <label>{summaryData?.["Total_Sms_NoResponse"]?.body ?? summaryData?.["Total_Sms_NoResponse"] ?? 0}</label>
                                  </div>
                              </div>
                          </div>
                        </div>
                  </div>
                  <div >

                      <div style={{background:"#dbdbdb", textAlign: "center", paddingRight: "10px", paddingLeft: "10px", fontSize: "14px"}}>
                              <label>Routed/Not Routed</label>
                      </div>
                       <div
                       
                       style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px",
                        border: "1px solid #ddd",
                        background: "white",
                        width: "auto",
                        paddingTop: "0px",
                        paddingBottom: "0px",
                        justifyContent: "center"
                        }}
                       >
                          <div style={{ fontSize: "12px", color: "black", display: "inline-flex", justifyContent: "center", alignItems: "center", fontWeight: "500"}}>
                              <div style={{ fontSize: "20px", marginRight: "8px", color: "#555", display: "inline-flex" }}>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Routed"
                                >
                                  <Icon icon={RouteIcon} width="20" height="20" style={{color: "green"}} />
                                  <label>{summaryData?.["Total_Scheduled"]?.body ?? summaryData?.["Total_Scheduled"] ?? 0}</label>
                                </div>
                                <div style={{
                                  display: "inline-flex",
                                  justifyContent: "center", 
                                  alignItems: "center",
                                  marginRight: "20px",
                                  flexDirection: "row",
                                  gap: "5px"
                                }}
                                title="Not Routed"
                                >
                                  <Icon icon={RouteIcon} width="20" height="20" style={{color: "orange"}} />
                                  <label>{summaryData?.["Total_NotScheduled"]?.body ?? summaryData?.["Total_NotScheduled"] ?? 0}</label>
                                  </div>
                              </div>
                          </div>
                        </div>
                  </div>
            </div>
            <div>
                <button className="btn btn-success d-flex flex-column justify-content-center align-items-center" onClick={handleSelectedRows}  title='RoboCall' style={{}}>
                    <Icon icon={sendIcon} width="32" height="32" />
                    <label>Send RoboCall</label>
                </button>
            </div>
            <div>
                <button className="btn btn-outline-success rounded-circle p-2" onClick={RefreshData}  title='Refresh Data' style={{border: "0px", borderRadius: "50%",padding: "10px"}}>
                    <Icon icon={refreshIcon} width="32" height="32" />
                </button>
            </div>
        </div>
        <VirtualizedTable  ref={tableRef} data={rowData} 
            columns={columns} height={"80vh"} 
            showCheckbox={true} hiddenColumns={columnsToHide}
            initialSelectedRows={initialSelectedRows}
            getRowStyle={getRowStyle}
        />
        </div>
        </>
    );
}
